import { ThemeColors } from '@contrast-security-inc/design-system-foundations'
import React from 'react'
import { Thermometer } from '../../legacy-design-system/thermometer'
import {
  VulnerabilityStatus,
  VulnerabilityStatusRegistry
} from '../../graphql/schema/shared'

export function getThermometerColor(status: VulnerabilityStatus): ThemeColors {
  switch (status) {
    case VulnerabilityStatusRegistry.SUSPICIOUS:
      return 'red50'
    case VulnerabilityStatusRegistry.REPORTED:
      return 'neutral100'
    case VulnerabilityStatusRegistry.CONFIRMED:
      return 'yellow50'
    default:
      return 'neutral50'
  }
}

export function VulnerabilityStatusThermometer({
  status,
  ratio,
  e2eTestId
}: {
  readonly status: VulnerabilityStatus
  readonly ratio: number
  readonly e2eTestId?: string
}) {
  return (
    <Thermometer
      fillColor={getThermometerColor(status)}
      fillRatio={ratio}
      e2eTestId={e2eTestId}
    />
  )
}
